import React, { useCallback, useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';
import { Controller, useFormContext } from 'react-hook-form';

import { FormLabel } from 'modules/automation/WorkflowBuilder/components';
import { displayActionCardHeader } from 'modules/automation/utils/displayActionCardHeader';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { generalContactListOptions } from 'constants/automation';
import useShareIntakeForms from 'modules/cases/hooks/useShareIntakeForms';
import debounce from 'lodash.debounce';

const CustomDropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <span className="pi pi-chevron-down" />
  </components.DropdownIndicator>
);

const ShareForm = ({ index }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { IntakeSearch } = useShareIntakeForms(null, []);

  const debouncedLoadOptions = useMemo(
    () =>
      debounce(async (inputValue, callback) => {
        try {
          const forms = await IntakeSearch(inputValue, false);
          callback(forms);
        } catch (err) {
          console.error(err);
          callback([]);
        }
      }, 500),
    []
  );

  const loadOptions = useCallback(
    (inputValue, callback) => {
      debouncedLoadOptions(inputValue, callback);
    },
    [debouncedLoadOptions]
  );

  return (
    <>
      {displayActionCardHeader('Form configuration')}
      <div className="d-flex flex-column flex-lg-row gap-3">
        <div className="w-100 w-lg-50">
          <FormLabel label="Forms" className="me-2" isRequired />
          <Controller
            name={`actions[${index}].form`}
            control={control}
            rules={{ required: 'Required' }}
            render={({ field: { value, onChange } }) => (
              <AsyncSelect
                getOptionLabel={(v) => v?.form_name}
                getOptionValue={(v) => v?.sk}
                placeholder="Select or Search"
                className="w-100"
                value={value}
                onChange={(e) => onChange(e)}
                cacheOptions
                defaultOptions
                loadOptions={loadOptions}
                noOptionsMessage={() => 'No Forms Found'}
                classNamePrefix="case-select"
                components={{ DropdownIndicator: CustomDropdownIndicator }}
              />
            )}
          />
          <RequiredValidation errors={errors} field={`actions.${index}.form`} />
        </div>

        <div className="w-100 w-lg-50">
          <FormLabel label="Contacts" isRequired />
          <Controller
            name={`actions[${index}].contact_assignees`}
            control={control}
            rules={{ required: 'Required' }}
            render={({ field: { name, value, onChange, ref } }) => (
              <Dropdown
                name={name}
                value={value}
                options={generalContactListOptions}
                onChange={(e) => onChange(e.value)}
                placeholder="Select Contacts"
                className="w-100 p-dropdown"
                filter
                display="chip"
                inputRef={ref}
              />
            )}
          />
          <RequiredValidation errors={errors} field={`actions.${index}.contact_assignees`} />
        </div>
      </div>
    </>
  );
};

export default ShareForm;
